// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Axis__legendAxis___BcMs1,
.Axis__horizontalLegendAxis___Bdj1S {
    font-family: var(--font-primary);
}

.Axis__axesContainer___whTQ_ {
    color: var(--color-bg-border);
}

.Axis__legendAxis___BcMs1 .tick text,
.Axis__horizontalLegendAxis___Bdj1S .tick text {
    font-size: 1.3rem;
    fill: var(--color-typo-primary);
}

.Axis__defaultTextColor___HXaEy .tick text {
    fill: var(--color-typo-secondary);
}

.Axis__horizontalLegendAxis___Bdj1S .tick:first-of-type text {
    text-anchor: start;
}

.Axis__horizontalLegendAxis___Bdj1S .tick:last-child text {
    text-anchor: end;
}

.Axis__legendAxis___BcMs1 .tick:first-of-type text {
    dominant-baseline: middle;
}

.Axis__oneElement___FKl_c .tick:first-of-type text {
    dominant-baseline: auto;
}

.Axis__oneHorizontalElement___BcMft .tick:last-child text {
    text-anchor: middle;
}

.Axis__legendAxis___BcMs1 .tick line,
.Axis__horizontalLegendAxis___Bdj1S .tick line {
    color: var(--color-bg-border);
}

.Axis__border___JCyTL {
    fill: none;
    stroke: var(--color-bg-border);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Legend/Axis/Axis.css"],"names":[],"mappings":"AAAA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,8BAA8B;AAClC","sourcesContent":[".legendAxis,\n.horizontalLegendAxis {\n    font-family: var(--font-primary);\n}\n\n.axesContainer {\n    color: var(--color-bg-border);\n}\n\n.legendAxis :global(.tick) text,\n.horizontalLegendAxis :global(.tick) text {\n    font-size: 1.3rem;\n    fill: var(--color-typo-primary);\n}\n\n.defaultTextColor :global(.tick) text {\n    fill: var(--color-typo-secondary);\n}\n\n.horizontalLegendAxis :global(.tick):first-of-type text {\n    text-anchor: start;\n}\n\n.horizontalLegendAxis :global(.tick):last-child text {\n    text-anchor: end;\n}\n\n.legendAxis :global(.tick):first-of-type text {\n    dominant-baseline: middle;\n}\n\n.oneElement :global(.tick):first-of-type text {\n    dominant-baseline: auto;\n}\n\n.oneHorizontalElement :global(.tick):last-child text {\n    text-anchor: middle;\n}\n\n.legendAxis :global(.tick) line,\n.horizontalLegendAxis :global(.tick) line {\n    color: var(--color-bg-border);\n}\n\n.border {\n    fill: none;\n    stroke: var(--color-bg-border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legendAxis": `Axis__legendAxis___BcMs1`,
	"horizontalLegendAxis": `Axis__horizontalLegendAxis___Bdj1S`,
	"axesContainer": `Axis__axesContainer___whTQ_`,
	"defaultTextColor": `Axis__defaultTextColor___HXaEy`,
	"oneElement": `Axis__oneElement___FKl_c`,
	"oneHorizontalElement": `Axis__oneHorizontalElement___BcMft`,
	"border": `Axis__border___JCyTL`
};
export default ___CSS_LOADER_EXPORT___;
